import React from 'react';

import { Button, Link, Stack } from '@mui/material';

import useImageUrlGenerator from '~/hooks/useImageUrlGenerator';

interface ImageLinkProps {
  imageId: string;
  activityId: string;
  onDelete: (activityId: string, imageId: string) => void;
}

function ImageLink({ imageId, activityId, onDelete }: ImageLinkProps) {
  const imageUrl = useImageUrlGenerator(imageId);

  return (
    <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
      <Link href={imageUrl} target="_blank" rel="noopener noreferrer">
        {imageId}
      </Link>
      <Button variant="outlined" size="small" color="error" onClick={() => onDelete(activityId, imageId)}>
        Delete
      </Button>
    </Stack>
  );
}

export default ImageLink;
